import SourceEvent from 'sources/sourceTypes/Event';
import { Event } from 'types';

export const toSource = (_obj: Event): SourceEvent => {
  return new SourceEvent();
};

export const toType = (sourceObj: SourceEvent): Event => {
  const event = new Event();

  event.id = sourceObj.id;
  event.title = sourceObj.title;
  event.description = sourceObj.description;
  event.price = sourceObj.price;
  event.basePrice = sourceObj.base_price;
  event.allowSingleSessionPurchase = sourceObj.allow_single_session_purchase;
  event.allowWaitlist = sourceObj.allow_waitlist;
  event.allowStaffSelection = sourceObj.allow_staff_selection;
  event.spotsRemaining = sourceObj.spots_remaining;
  event.enableDynamicPricing = sourceObj.enable_dynamic_pricing;
  event.singleSessionPrice = sourceObj.single_session_price;
  event.participantCount = sourceObj.participant_count;
  event.privacy = sourceObj.privacy;
  event.url = sourceObj.url;
  event.path = sourceObj.path;
  event.adminPath = sourceObj.admin_path;
  event.status = sourceObj.status;
  // event.image = sourceObj.image;
  // event.imageDimensions = sourceObj.image_dimensions;
  // event.eventType = sourceObj.event_type;
  // event.purchasedRegistrations = sourceObj.purchased_registrations;
  // event.registrations = sourceObj.registrations;
  event.sessionIds = sourceObj.session_ids;
  event.scheduleType = sourceObj.schedule_type;
  // event.schedules = sourceObj.schedules;
  // event.exclusiveMembershipIds = sourceObj.exclusive_membership_ids;
  event.productType = sourceObj.product_type;
  // event.createdAt = sourceObj.created_at;
  // event.updatedAt = sourceObj.updated_at;
  return event;
};
